import React from "react";
import styles from "./PriceBreakoutSection.module.scss";
import Text from "@components/atoms/Text";
import { formatCurrencyINR } from "@utils/numberFormatter";

interface PriceBreakoutSectionProps {
  charges: { label: string; value: string | null }[];
  discounts: { label: string; value: string | null }[];
  finalPrice: string;
  isSellable: boolean;
  consumerSavings?: string;
  savingBalance?: any;
}

export default function PriceBreakoutSection({
  charges,
  discounts,
  finalPrice,
  isSellable,
  consumerSavings,
  savingBalance
}: PriceBreakoutSectionProps) {
  return (
    <div className={styles.containerWrapper}>
      <div className={styles.container}>
        {charges?.map(
          ({ label, value }) =>
            value && (
              <div key={label} className={styles.row}>
                <p className={styles.label}>{label}</p>
                <p className={styles.value}>{value}</p>
              </div>
            )
        )}
        {consumerSavings && (
          <>
            <div className={styles.divider}></div>
            <div key="consumer-savings" className={styles.row}>
              <p className={styles.label}>Consumer Savings</p>
              <p className={styles.value}>{consumerSavings}</p>
            </div>
          </>
        )}

        <div className={styles.divider}></div>

        {discounts?.map(
          ({ label, value }) =>
            value && (
              <div key={label} className={styles.row}>
                <p className={styles.label}>{label}</p>
                <p
                  className={
                    label === "ACKO Drive discount"
                      ? styles.discount
                      : styles.value
                  }
                >
                  {value}
                </p>
              </div>
            )
          )}
          {
            savingBalance > 0 && (
              <Text className={styles.savingBalanceText} >(<span className={styles.savingBalanceValue} >{formatCurrencyINR(savingBalance)}</span> New car savings balance applied)</Text>
            )
          }
      </div>
      {isSellable && (
        <div className={styles.finalPriceBox}>
          <div className={styles.row}>
            <p className={styles.finalLabel}>ACKO Drive price</p>
            <p className={styles.finalValue}>{finalPrice}</p>
          </div>
        </div>
      )}
    </div>
  );
}
